<script setup lang="ts">
defineProps(["error"]);

const handleError = () => clearError({ redirect: "/" });
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator />

    <div class="container mt-200">
      <div class="inner-page">
        <h2>Sidan kan inte hittas</h2>
        <p class="text-20">Vänligen kontrollera adressen eller <a href="/" @click.prevent="handleError">gå till startsidan</a></p>
      </div>
    </div>

  </NuxtLayout>
</template>
